import { AvgQuestionAskedGraphData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgQuestionAsked/AvgQuestionAskedGraphData";
import { AvgQuestionAskedRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgQuestionAsked/AvgQuestionAskedRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

export const AvgQuestionAsked = () => {
  const { selectedDialogTab } = useVideoAnalytics();
  return <div>{selectedDialogTab === "Raw Data" ? <AvgQuestionAskedRawData /> : <AvgQuestionAskedGraphData />}</div>;
};
